import { create } from "zustand";
import { persist } from "zustand/middleware";
import { queryClient } from "@/lib/api/query-client";
import { AuthUser } from "@/features/auth/types";

interface AuthState {
  user: AuthUser | null;
  // token: string | null;
  // expiresAt: number | null;
  isAuthenticated: boolean;
  login: (user: AuthUser) => void;
  logout: () => void;
  setUser: (user: AuthUser) => void;
  updateUser: (user: Partial<AuthUser>) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      // token: null,
      // expiresAt: null,
      isAuthenticated: false,
      login: (user) => {
        // const expiryTime = (expiresIn || 3600) * 1000;
        // const expiresAt = new Date().getTime() + expiryTime;

        // localStorage.setItem("admin_token", token);
        set({ user, isAuthenticated: true });
      },
      logout: () => {
        // localStorage.removeItem("admin_token");
        set({
          user: null,
          // token: null,
          // expiresAt: null,
          isAuthenticated: false,
        });
        queryClient.clear();
      },
      setUser: (user) => {
        // Skip no-op writes (e.g. profile refetch returning identical data)
        // so subscribers don't re-render the whole tree.
        const current = get().user;
        if (
          current &&
          user &&
          JSON.stringify(current) === JSON.stringify(user)
        ) {
          return;
        }
        set({ user });
      },
      updateUser: (updates) => {
        const currentUser = get().user;
        if (currentUser) {
          set({ user: { ...currentUser, ...updates } });
        }
      },
    }),
    {
      name: "auth-storage",
      partialize: (state) => ({
        user: state.user,
        // token: state.token,
        isAuthenticated: state.isAuthenticated,
        // expiresAt: state.expiresAt,
      }),
    }
  )
);
